import React, { MutableRefObject } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

interface ITermsOfServiceContainerProps {
  isTosChecked: boolean;
  isMarketingConsentChecked: boolean;
  onTosChange: (checked: boolean) => void;
  onMarketingConsentChange: (checked: boolean) => void;
}

function TermsOfServiceContainer({
  isTosChecked,
  isMarketingConsentChecked,
  onTosChange,
  onMarketingConsentChange,
}: ITermsOfServiceContainerProps) {
  const countryCode = useSelector((state: any) => state.company.country_code);
  return (
    <div className="tos-container mt-4 text-center">
      {countryCode === "SG" ? (
        <div className="d-flex flex-column text-left">
          <div className="d-flex align-items-center my-2">
            <input
              type="checkbox"
              checked={isTosChecked}
              onChange={(e) => onTosChange(e.target.checked)}
              className="mr-2"
            />
            <span className="tos-text-desktop">
              <FormattedMessage
                id="registration.agree_to_tos"
                defaultMessage="I agree to the <buttonTag>Terms of Service</buttonTag>."
                values={{
                  buttonTag: (text: string) => (
                    <a href="/terms-of-service">{text}</a>
                  ),
                }}
              />
            </span>
          </div>
          <div className="d-flex align-items-center my-2">
            <input
              type="checkbox"
              checked={isMarketingConsentChecked}
              onChange={(e) => onMarketingConsentChange(e.target.checked)}
              className="mr-2"
            />
            <FormattedMessage
              id="registration.marketing_consent"
              defaultMessage="I agree to receive promotional content and updates."
            />
          </div>
          <p className="mandatory-fields mt-2">
            <FormattedMessage
              id="registration.mandatory_fields"
              defaultMessage="All fields marked with an asterisk (*) are mandatory."
            />
          </p>
        </div>
      ) : (
        <FormattedMessage
          id="registration.terms_of_service"
          defaultMessage="By signing-in to your account, you agree to {breakTag}our <buttonTag>Terms of Service</buttonTag>."
          values={{
            breakTag: <br />,
            buttonTag: (text: string) => (
              <a href="/terms-of-service">{text}</a>
            ),
          }}
        />
      )}
    </div>
  );
}

export default TermsOfServiceContainer;
